import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';
import { useEffect, useRef, useState } from 'react';
import SimpleBar from 'simplebar-react';

import DateCalendarCustom from 'src/components/calendar/DateCalendarCustom';
import GroupCheckbox from 'src/components/calendar/GroupCheckbox';
// import BtnGradient from 'src/components/common/button/BtnGradient';
import CalendarScheduleCustom from 'src/components/calendar/CalendarScheduleCustom';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import { useStore } from 'src/context/StoreContext';
// import { generateRandomString } from 'src/common/helper';

const sizeIcon = {
  bgcolor: '#FFFFFF',
  borderRadius: '50%',
  padding: '2px',
  height: '28px',
  width: '28px',
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
};

const CalendarSchedule = () => {
  const [openFilter, setOpenFilter] = useState(false);
  // const [keyCalendar, setKeyCalendar] = useState(generateRandomString(5));
  const clearRef = useRef<any>();
  const scheduleCustomRef = useRef<any>();
  const storeContext = useStore();

  useEffect(() => {
    storeContext.setTabCalendar('schedule');
    // eslint-disable-next-line
  }, []);

  const handleOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  return (
    <Box>
      <Stack
        direction={'row'}
        spacing='20px'
        sx={{ width: '100%' }}
        position={'relative'}
      >
        <Stack>
          <Box display={'flex'} justifyContent='flex-end'>
            <Box
              sx={{
                ...sizeIcon,
                // ...(!openFilter ? {
                //   position: 'absolute',
                //   left: '-20px',
                //   top: '0px'
                // } : {}
                // )
              }}
            >
              <Box
                component={'img'}
                src={
                  openFilter
                    ? `/images/icons/ic-menu-active.svg`
                    : `/images/icons/ic-menu.svg`
                }
                alt=''
                sx={{
                  cursor: 'pointer',
                  width: '24px',
                }}
                onClick={handleOpenFilter}
              />
            </Box>
          </Box>
          <Collapse
            in={openFilter}
            collapsedSize={'0px'}
            orientation='horizontal'
          >
            <Stack justifyContent={'space-between'}>
              <Stack
                sx={{
                  '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before':
                    { backgroundColor: '#CCD1D9' },
                }}
              >
                <DateCalendarCustom />
                <SimpleBar
                  style={{ height: 'calc(100vh - 415px)', borderWidth: '18px' }}
                >
                  <GroupCheckbox sx={{ mt: '17px' }} ref={clearRef} />
                </SimpleBar>
              </Stack>
              <Stack direction={'row'} spacing={'8px'} justifyContent={'right'}>
                <BtnOutlineGradient
                  text='クリア'
                  handleButtonClick={() => clearRef?.current?.handleClear()}
                />
              </Stack>
            </Stack>
          </Collapse>
        </Stack>

        <CalendarScheduleCustom
          openFilter={openFilter}
          ref={scheduleCustomRef}
        />
      </Stack>
    </Box>
  );
};

export default CalendarSchedule;
